export const REPORT_GROUP_DISFUNCTIONS = 'disfunctions';
export const REPORT_GROUP_PRODUCTIVITY = 'productivity';
export const REPORT_GROUP_OEE = 'oee';
export const REPORT_GROUP_OTHERS = 'others';

export const gqlGroupMap = {
  [REPORT_GROUP_DISFUNCTIONS]: 'DISFUNCTIONS',
  [REPORT_GROUP_PRODUCTIVITY]: 'PRODUCTIVITY',
  [REPORT_GROUP_OEE]: 'OEE',
  [REPORT_GROUP_OTHERS]: 'OTHERS'
};
